import React from 'react';
import { connectStats } from 'react-instantsearch-dom';
import ProgressBar from '@components/common/ProgressBar';

interface StatsProps {
  nbHits: any
  hits: any
}

const Stats = ({ nbHits, hits }: StatsProps) => {
  const percentage = (100 * hits.length / nbHits).toFixed();

  return <ProgressBar progressPercentage={percentage} />
};

const StatsWithProgressBar = connectStats(Stats)

export default StatsWithProgressBar
